import { IsNotEmpty } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';
export class LessorRepresentativeDto extends EpimsBaseEntityDto {
  LessorRepId: string;
  LandTitleId: string;
  AddressBookId: string;
  LessorsId: string;
  LessorRepTypeId: string;
  FromDate: Date;
  ToDate: Date;
}
